import React, { useEffect, useState, useMemo } from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'astroturf/react';
import { Link } from './Link';
import { getWork } from 'js/social/api/work_api';
import { InversePaperIcon as InversePaperIconBase } from '../Icons';

const InversePaperIcon = styled(InversePaperIconBase)`
  margin-right: 2px;
  top: 2px;
  position: relative;
  width: 14px;
  height: 14px;
`;

const PaperLink = styled(Link)`
  font-weight: 500;
`;

export const PaperLinkElement: React.FC<RenderElementProps> = ({
  attributes,
  element,
  children,
}) => {
  const [paperTitle, setPaperTitle] = useState<string | null>(null);
  const [paperUrl, setPaperUrl] = useState<string>('');

  useEffect(() => {
    async function fetchWorkData() {
      try {
        const paper = await getWork({
          id: element.data.workId,
          slug: '',
        });

        setPaperUrl(paper.url);
        setPaperTitle(paper.title);
      } catch {
        // Reasonable for this to throw a 404. In any case, do nothing.
      }
    }

    fetchWorkData();
  }, [element]);

  const urlFromTypedText = useMemo(() => {
    let typedUrl = element.data.text;
    if (typedUrl.indexOf('http') !== 0) {
      typedUrl = 'https://' + typedUrl;
    }
    try {
      return new URL(typedUrl).href;
    } catch {
      return typedUrl;
    }
  }, [element]);

  if (paperTitle === null) {
    return (
      <PaperLink
        {...(({ ref: _, ...rest }) => rest)(attributes)}
        href={urlFromTypedText}
        contentEditable={false}
      >
        {children}
        {element.data.text}
      </PaperLink>
    );
  }

  return (
    <PaperLink
      {...(({ ref: _, ...rest }) => rest)(attributes)}
      href={paperUrl}
      contentEditable={false}
    >
      {children}
      <InversePaperIcon />
      {paperTitle}
    </PaperLink>
  );
};
